import { useState } from "react";
import { UserRound } from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CrudPage from "@/components/admin/CrudPage";
import { PEOPLE_ROLES, fileUrl } from "@/lib/activity";

const fieldsFor = (role) => [
  { name: "photo_path", label: "Foto", type: "image", folder: "people", full: true },
  { name: "name", label: "Nama Lengkap", required: true },
  { name: "phone", label: "No. WhatsApp", placeholder: "08xxxxxxxxxx" },
  ...(role === "pemateri" ? [{ name: "expertise", label: "Bidang Keahlian", placeholder: "Fiqih, Tafsir, Hadits..." }] : []),
  { name: "notes", label: "Keterangan", type: "textarea" },
];

const columnsFor = (role) => [
  { key: "photo_path", label: "", className: "w-14", render: (p) => p.photo_path ? <img src={fileUrl(p.photo_path)} alt="" className="h-10 w-10 rounded-xl object-cover" /> : <div className="h-10 w-10 rounded-xl bg-emerald-50 text-emerald-800 flex items-center justify-center"><UserRound size={16} /></div> },
  { key: "name", label: "Nama", className: "font-medium" },
  { key: "phone", label: "WhatsApp", className: "text-slate-500" },
  ...(role === "pemateri" ? [{ key: "expertise", label: "Bidang Keahlian" }] : []),
  { key: "notes", label: "Keterangan", className: "text-slate-500 max-w-xs truncate" },
];

export const MasterData = () => {
  const [role, setRole] = useState("pemateri");
  return (
    <div data-testid="master-data">
      <Tabs value={role} onValueChange={setRole}>
        <TabsList className="rounded-full bg-white border border-emerald-900/10 p-1 h-auto flex-wrap">
          {Object.entries(PEOPLE_ROLES).map(([k, v]) => (
            <TabsTrigger key={k} value={k} className="rounded-full data-[state=active]:bg-[#0d3b2e] data-[state=active]:text-white" data-testid={`master-tab-${k}`}>{v}</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="mt-4">
        <CrudPage
          key={role}
          embedded
          endpoint="people"
          query={`role=${role}`}
          prefix={`admin-people-${role}`}
          itemLabel={PEOPLE_ROLES[role]}
          fields={fieldsFor(role)}
          columns={columnsFor(role)}
          defaults={{ role, name: "", phone: "", photo_path: "", expertise: "", notes: "" }}
          searchKeys={["name", "phone", "expertise"]}
        />
      </div>
    </div>
  );
};
